/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tenant-access.reducer';

export const TenantAccessDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tenantAccessEntity = useAppSelector(state => state.tenantAccess.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tenantAccessDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tenantAccess.detail.title">TenantAccess</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tenantAccess.id">Id</Translate>
            </span>
          </dt>
          <dd>{tenantAccessEntity.id}</dd>
          <dt>
            <span id="uhid">
              <Translate contentKey="tinyMedicRestApp.tenantAccess.uhid">Uhid</Translate>
            </span>
          </dt>
          <dd>{tenantAccessEntity.uhid}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tenantAccess.active">Active</Translate>
            </span>
          </dt>
          <dd>{tenantAccessEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="revoked">
              <Translate contentKey="tinyMedicRestApp.tenantAccess.revoked">Revoked</Translate>
            </span>
          </dt>
          <dd>{tenantAccessEntity.revoked ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tenantAccess.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{tenantAccessEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tenantAccess.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{tenantAccessEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tenantAccess.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{tenantAccessEntity.lastUpdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tenantAccess.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{tenantAccessEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantAccess.comboUser">Combo User</Translate>
          </dt>
          <dd>{tenantAccessEntity.comboUser ? tenantAccessEntity.comboUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantAccess.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{tenantAccessEntity.glucoUser ? tenantAccessEntity.glucoUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tenant-access" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tenant-access/${tenantAccessEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TenantAccessDetail;
